module.exports = __webpack_public_path__ + "img/cash-icon.8ce60c25.png";